import AuthService from "../services/auth";
import cookie from 'react-cookies';
import { hashHistory } from 'react-router';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_USER = 'GET_USER';

export function initAuth() {
  return (dispatch) => {
    let userId = cookie.load('userId');
    let location = hashHistory.getCurrentLocation();
    if (location.pathname == '/login/') {
      if (userId){
        AuthService.getUser().then((response) => {
          dispatch({
            type: SET_USER,
            response
          });
          hashHistory.push('/companies/list/');
        }, () => {
           AuthService.logout()
          .then(() => {
            dispatch({
              type: LOGOUT_USER
            });
          });
        });
      }
    }
    else {
      if (!userId && (location.pathname != '/admin')) {
        hashHistory.push('/login/');
      }
    }
  };
}


export function login(query) {
  return (dispatch) => {
    AuthService.login(query)
    .then((response) => {
      dispatch({
        type: LOGIN_USER,
        response
      });
      hashHistory.push('/companies/list/');
    });
  };
}

export function logout() {
  return (dispatch) => {
    AuthService.logout()
    .then(() => {
      dispatch({
        type: LOGOUT_USER
      });
      hashHistory.push('/login/');
    }, () => {
      hashHistory.push('/login/');
    });
  };
}

export function getUser() {
  return (dispatch) => {
     dispatch({
          type: GET_USER
        });
  };
}



// WEBPACK FOOTER //
// ./actions/auth.js